

































































































































































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import {
  IcoachSkillFullInfo,
  TsManagerRatingType,
  SurveyInfo,
  TsRateeUser,
  TsRaterRateeSkillRating,
  TsRatingForm,
  TsUserDto,
  User,
  TsManagerRatingTypeEnum
} from '@/interfaces'
import { Getter } from 'vuex-class'
import RaterRateeCard from '@/components/360/RaterRateeCard.vue'
import TsService from '@/services/TsService'
import RangeSlider from '@/components/common/rangeSlider/RangeSlider.vue'
import AppFooter from '@/components/footer/AppFooter.vue'

@Component({
  name: 'ManagerRatingPage',
  components: {
    RaterRateeCard,
    RangeSlider,
    AppFooter
  }
})
export default class ManagerRatingPage extends Vue {
  @Prop({ required: true })
  tsSurveyId !: number

  @Prop({ required: true })
  tsRaterRateeId !: number

  @Prop({ required: true })
  type !: TsManagerRatingType

  @Getter('user/currentUser')
  user!: User

  @Getter('ts/getUsers')
  tsUserInfo!: TsUserDto

  @Getter('user/isAuthenticated')
  isAuthenticated!: boolean

  @Getter('survey/getDisplayedBaseSurveyInfo')
  surveyInfo!: SurveyInfo

  @Ref()
  scoreRange!: RangeSlider

  @Watch('type')
  async onTypeChanged () {
    await this.updateManagerRating()
  }

  ratee: TsRateeUser | null = null
  skillInfo: IcoachSkillFullInfo | null = null
  ratings: TsRaterRateeSkillRating[] = []
  ratingForm: TsRatingForm = { comment: '', score: 1 }
  rateeMobileNav: boolean = false;
  ratingValues: number[] = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10
  ]

  get isFormDisplayed (): boolean {
    if (this.type === TsManagerRatingTypeEnum.EVERYDAY) {
      return true
    }

    return this.ratings.length === 0
  }

  async toggleRateeMobileNav () {
    this.rateeMobileNav = !this.rateeMobileNav
  }

  async created () {
    if (!this.isAuthenticated) {
      await this.$router.push({ name: 'notFound' })
    }

    if (!this.ratee) {
      this.ratee = await TsService.getRateeInfoById(this.tsRaterRateeId)
    }

    await this.updateManagerRating()
  }

  goToList (): void {
    this.$router.push({
      name: 'survey.ts.user.ratee',
      params: {
        tsRaterRateeId: this.tsRaterRateeId.toString()
      }
    })
  }

  updateValues (value: number) {
    this.ratingForm.score = value / 10
  }

  async updateManagerRating (): Promise<void> {
    this.ratings = await TsService.getManagerRatings(this.tsRaterRateeId, this.type)
  }

  async rate () {
    if (!await this.$validator.validateAll()) {
      return
    }

    try {
      const result = await TsService.addManagerRating(this.tsRaterRateeId, this.ratingForm, this.type)

      this.updateRating(result)
      this.scoreRange.reset()
    } catch (error) {
      if ('response' in error && error.response.status === 400) {
        this.handleSkillRatingErrors(error.response.data)
      }
    }
  }

  scoreFormatFromString (score: string): string {
    return parseFloat(score).toFixed(1)
  }

  updateRating (rating: TsRatingForm) {
    this.ratings.unshift({
      comment: rating.comment,
      score: rating.score
    })

    this.$validator.reset()
    this.ratingForm = {
      score: 1,
      comment: ''
    }

    if (this.skillInfo) {
      this.skillInfo.status = true
    }
  }

  handleSkillRatingErrors (data: object) {
    // todo::add handle logic
  }
}
